import { palette } from '@/theme/constants';
import { keyframes } from '@mui/system';
export const styles = {
  icon: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    backgroundColor: palette.cardBackground,
    border: `0.063rem solid ${palette.cardBorder}`,
  },
};


export const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.7;
  }
`;

